<div class="combo-box-select-wrapper">
  <!-- Loading state -->
  <div class="combo-box-loading-container" *ngIf="loading">
    <mat-spinner [diameter]="20" class="spinner-inline"></mat-spinner>
    <span class="loading-text">Loading...</span>
  </div>
  
  <!-- Normal combo box when not loading -->
  <div class="combo-box-input-container" [class.focused]="isInputFocused" *ngIf="!loading">
    <input 
      class="combo-box-name-input"
      [(ngModel)]="selectedValue"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="onKeyDown($event)"
      (ngModelChange)="onInputChange()"
      [placeholder]="placeholder"
      [readonly]="readonly"
    />
    <button 
      type="button"
      class="dropdown-trigger"
      (click)="toggleDropdown()"
      [class.open]="isDropdownOpen">
      <mat-icon>{{ isDropdownOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
  </div>
  
  <div class="dropdown-panel" *ngIf="isDropdownOpen && !loading" [style.max-height]="dropdownMaxHeight">
    <!-- Fixed search box at the top -->
    <div class="dropdown-search-container" *ngIf="shouldShowFilter">
      <input 
        class="dropdown-search-input"
        [(ngModel)]="searchValue"
        (ngModelChange)="onSearchChange()"
        placeholder="Search items..."
        (click)="$event.stopPropagation()"
      />
      <mat-icon class="search-icon">search</mat-icon>
    </div>
    
    <!-- Scrollable list area -->
    <div class="dropdown-list-area" [style.max-height]="listAreaMaxHeight">
      <div class="dropdown-option" 
           *ngFor="let item of filteredItems"
           (click)="selectItem(item)"
           [class.selected]="isItemSelected(item)">
        <span>{{ item.name }}</span>
      </div>
      
      <!-- Show "No matches" when filtering returns empty results -->
      <div class="dropdown-option no-matches" *ngIf="shouldShowFilter && filteredItems.length === 0 && searchValue.trim()">
        <span>No matches found</span>
      </div>
      
      <!-- Show "No items" when the list is completely empty -->
      <div class="dropdown-option no-items" *ngIf="items.length === 0">
        <span>No items available</span>
      </div>
    </div>
  </div>
</div>
